import type { CsmRosterBridge } from '../../../api/dashboard';
import { formatCompact, formatNumber } from '../../../utils/numberFormat';

/** The companies named in full; the rest are summed into one "+ N more". */
const NAMED = 2;

/**
 * "3.0B aOS tokens on the platform = 2.94B on the CSM roster + 82.6M Orange +
 * 14.8M Jo Hillman + …": how a Usage total reconciles with the roster's figure
 * on Customers. Both sides use the same rule.
 */
export function RosterBridge({
  platform,
  total,
  bridge,
  days,
  note,
}: {
  /** "aOS" or "Classic". */
  platform: string;
  total: number;
  bridge: CsmRosterBridge;
  days: number;
  /** What both sides count, e.g. "SEQUESTO staff are left out on both sides". */
  note: string;
}) {
  const named = bridge.notOnRoster.slice(0, NAMED);
  const rest = bridge.notOnRoster.slice(NAMED);
  const restTokens = rest.reduce((n, r) => n + r.tokens, 0);
  const c = (v: number) => <span title={formatNumber(v)}>{formatCompact(v) || '0'}</span>;
  return (
    <p className="text-body-xs text-text-tertiary">
      <span title={`${note}${days === 30 ? ' The roster figure uses the same companies and window as Customers.' : ''}`}>
        Last {days} days: {c(total)} {platform} tokens = {c(bridge.onRoster)} on the roster
      </span>
      {named.map((r) => (
        <span key={r.name}>
          {' '}+ {c(r.tokens)} {r.name}
          {r.listedAs ? ` (on the list as ${r.listedAs})` : r.personal ? ' (personal)' : ' (not on the list)'}
        </span>
      ))}
      {rest.length > 0 && (
        <span title={rest.map((r) => `${r.name}${r.personal ? ' (personal workspace)' : ''}: ${formatNumber(r.tokens)}`).join('\n')}>
          {' '}+ {c(restTokens)} in {rest.length} more
        </span>
      )}
      {bridge.notOnRoster.length === 0 && ', every company with usage is on the roster'}.
    </p>
  );
}
